import { Link } from "react-router-dom";
import { Card, Button, Row, Col } from "react-bootstrap";
import imgInicial from "../../assets/images/nivelinicial.jpg";
import imgPrimario from "../../assets/images/primaria.jpg";
import imgSecundario from "../../assets/images/nivelsecundario.png";

function HomePage() {
  return (
    <div className="container mt-3 py-4">
      <Row xs={1} md={3} className="g-4">

        {/* INICIAL */}
        <Col>
          <Card className="card text-bg-dark border-0 rounded-4 h-100 position-relative overflow-hidden texto-animado shadow-lg" >
            <Card.Img  variant="top" src={imgInicial} alt="Nivel Inicial" style={{ objectFit: "cover", height: "250px" }}
            />
            <Card.Body className="d-flex flex-column">
              <Card.Title className="fw-bold fs-4 text-center">Inicial</Card.Title>
              <Card.Text className="flex-grow-1 text-center">
                Acompañamos a los más pequeños en sus primeros pasos educativos con amor,
                juego y contención. Promovemos el desarrollo integral a través de propuestas lúdicas,
                exploración creativa y vínculos afectivos.
              </Card.Text>
              <div className="text-center mt-3">
                <Link to="/homeinicial">
                  <Button variant="warning" className="fw-bold">Leer más</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* PRIMARIO */}
        <Col>
          <Card className="card text-bg-dark border-0 rounded-4 h-100 position-relative overflow-hidden texto-animado shadow-lg4">
            <Card.Img
              variant="top"
              src={imgPrimario}
              alt="Nivel Primario"
              style={{ objectFit: "cover", height: "250px" }}
            />
            <Card.Body className="d-flex flex-column">
              <Card.Title className="fw-bold fs-4 text-center">Primario</Card.Title>
              <Card.Text className="flex-grow-1 text-center">
                Brindamos una educación sólida y personalizada, que combina conocimientos,
                habilidades socioemocionales y pensamiento crítico.
              </Card.Text>
              <div className="text-center mt-3">
                <Link to="/nivelprimario">
                  <Button variant="warning" className="fw-bold">Leer más</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* SECUNDARIO */}
        <Col>
          <Card className="card text-bg-dark border-0 rounded-4 h-100 position-relative overflow-hidden texto-animado shadow-lg">
            <Card.Img
              variant="top"
              src={imgSecundario}
              alt="Nivel Secundario"
              style={{ objectFit: "cover", height: "250px" }}
            />
            <Card.Body className="d-flex flex-column">
              <Card.Title className="fw-bold fs-4 text-center">Secundario</Card.Title>
              <Card.Text className="flex-grow-1 text-center">
                Nuestros jóvenes se preparan para los desafíos del mundo actual,
                fortaleciendo su pensamiento reflexivo, su autonomía y su responsabilidad
                con proyectos innovadores.
              </Card.Text>
              <div className="text-center mt-3">
                <Link to="/nivelsecundario">
                  <Button variant="warning" className="fw-bold">Leer más</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>

      </Row>
    </div>
  );
}

export default HomePage;
